/**
 * ⚠️  AUTO-GENERATED FILE - DO NOT EDIT MANUALLY ⚠️
 *
 * This file is generated by generate-feature-flags.ts from feature-flags-registry.json.
 * To add or modify feature flags, edit feature-flags-registry.json and run: npm run generate:feature-flags
 *
 * @generated
 * @hash f213b9914c945231
 */

import AnalyticsFlags from './analytics/flags';
import analyticsFlagsClient from './analytics/flagsClient';
import MatchmakingFlags from './match-making/flags';
import matchmakingFlagsClient from './match-making/flagsClient';
import CommunitiesFlags from './communities/flags';
import communitiesFlagsClient from './communities/flagsClient';
import { type FeatureFlagsClient, type TFlagsByNamespace } from './types';

export enum FeatureFlagNamespace {
  Analytics = 'Analytics',
  Matchmaking = 'Matchmaking',
  Communities = 'Communities',
}

export const FeatureFlagsByNamespace = {
  [FeatureFlagNamespace.Analytics]: {
    flags: AnalyticsFlags,
    client: analyticsFlagsClient,
  },
  [FeatureFlagNamespace.Matchmaking]: {
    flags: MatchmakingFlags,
    client: matchmakingFlagsClient,
  },
  [FeatureFlagNamespace.Communities]: {
    flags: CommunitiesFlags,
    client: communitiesFlagsClient,
  },
} as const satisfies {
  [Namespace in FeatureFlagNamespace]: {
    flags: TFlagsByNamespace[Namespace];
    client: FeatureFlagsClient<Namespace>;
  };
};
